import IGlobalConfig from "../types/IGlobalConfig";

const overlaid = new WeakMap<IGlobalConfig, IGlobalConfig>();

/**
 * Replaces service URLs on a loaded global config with the dev-only overrides
 * from `local.env`. Returns the input unchanged when it has no `authServiceUrl`
 * yet or when no overrides are defined (always the case in release builds).
 */
export function applyLocalServiceUrls<T extends IGlobalConfig | null | undefined>(
  config: T
): T {
  if (!config?.authServiceUrl || Object.keys(__LOCAL_SERVICE_URLS__).length === 0) {
    return config;
  }
  let result = overlaid.get(config);
  if (!result) {
    result = { ...config, ...__LOCAL_SERVICE_URLS__ };
    overlaid.set(config, result);
  }
  return result as T;
}
